class IsPersonalization extends HTMLElement {
  connectedCallback() {
    this.nameInput = this.querySelector('[data-is-name]');
    this.titleInput = this.querySelector('[data-is-title]');
    this.fontInput = this.querySelector('[data-is-font]');
    this.nameOutput = this.querySelector('[data-is-name-output]');
    this.titleOutput = this.querySelector('[data-is-title-output]');
    this.preview = this.querySelector('[data-is-nameplate]');
    this.form = document.getElementById(this.nameInput?.getAttribute('form'));

    this.nameInput?.addEventListener('input', () => this.update());
    this.titleInput?.addEventListener('input', () => this.update());
    this.nameInput?.addEventListener('invalid', (event) => this.handleInvalid(event));
    this.titleInput?.addEventListener('invalid', (event) => this.handleInvalid(event));
    this.fontInput?.addEventListener('change', () => this.update());
    this.form?.addEventListener('invalid', (event) => this.handleInvalid(event), true);
    this.update();
  }

  handleInvalid(event) {
    if (!this.contains(event.target)) return;
    event.target.setAttribute('aria-invalid', 'true');
    event.target.addEventListener('input', () => event.target.removeAttribute('aria-invalid'), { once: true });
  }

  update() {
    if (this.nameOutput) {
      this.nameOutput.textContent = this.nameInput?.value.trim() || this.nameOutput.dataset.defaultText || 'İsim Soyisim';
    }
    if (this.titleOutput) {
      this.titleOutput.textContent = this.titleInput?.value.trim() || this.titleOutput.dataset.defaultText || 'Ünvan';
    }
    if (this.preview) this.preview.dataset.font = this.fontInput?.value || 'serif';
  }
}

if (!customElements.get('is-personalization')) {
  customElements.define('is-personalization', IsPersonalization);
}

class IsCookieConsent extends HTMLElement {
  connectedCallback() {
    this.banner = this.querySelector('[data-cookie-banner]');
    this.preferences = this.querySelector('[data-cookie-preferences]');
    this.status = this.querySelector('[data-cookie-status]');
    this.querySelector('[data-cookie-accept]')?.addEventListener('click', () => this.save(true, true, true));
    this.querySelector('[data-cookie-reject]')?.addEventListener('click', () => this.save(false, false, false));
    this.querySelector('[data-cookie-customize]')?.addEventListener('click', () => this.togglePreferences());
    this.querySelector('[data-cookie-save]')?.addEventListener('click', () => {
      this.save(
        this.querySelector('[name="cookie_analytics"]')?.checked === true,
        this.querySelector('[name="cookie_marketing"]')?.checked === true,
        this.querySelector('[name="cookie_preferences"]')?.checked === true
      );
    });

    window.Shopify?.loadFeatures?.(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify?.customerPrivacy) {
          this.show();
          return;
        }

        const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        const undecided = !consent.analytics && !consent.marketing && !consent.preferences;
        if (window.Shopify.customerPrivacy.shouldShowBanner?.() || undecided) this.show();
      }
    );
  }

  show() {
    this.banner?.removeAttribute('hidden');
  }

  togglePreferences() {
    const expanded = this.preferences?.hasAttribute('hidden');
    this.preferences?.toggleAttribute('hidden', !expanded);
    this.querySelector('[data-cookie-customize]')?.setAttribute('aria-expanded', String(expanded));
    if (expanded) this.preferences?.querySelector('input')?.focus();
  }

  save(analytics, marketing, preferences) {
    if (!window.Shopify?.customerPrivacy) {
      if (this.status) this.status.textContent = 'Tercihler şu anda kaydedilemedi. Lütfen yeniden deneyin.';
      return;
    }

    window.Shopify.customerPrivacy.setTrackingConsent(
      { analytics, marketing, preferences },
      () => {
        this.banner?.setAttribute('hidden', '');
        if (this.status) this.status.textContent = 'Çerez tercihleriniz kaydedildi.';
      }
    );
  }
}

if (!customElements.get('is-cookie-consent')) {
  customElements.define('is-cookie-consent', IsCookieConsent);
}

document.querySelectorAll('.product__description h4').forEach((heading) => {
  const replacement = document.createElement('h3');
  [...heading.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
  replacement.innerHTML = heading.innerHTML;
  heading.replaceWith(replacement);
});

const isMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const isMotionItems = new WeakSet();
let isMotionObserver;

const isRevealSelectors = [
  '.is-hero__copy > *',
  '.is-hero__media',
  '.is-trust__item',
  '.is-section-heading > *',
  '.is-collection',
  '.is-featured-products__header > *',
  '.is-featured-products .grid__item',
  '.is-personalization-story__media',
  '.is-personalization-story__copy > *',
  '.is-b2b__grid > *',
  '.is-maker__copy > *',
  '.is-maker__media',
  '.is-guide',
];

function getMotionObserver() {
  if (isMotionObserver) return isMotionObserver;

  isMotionObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  return isMotionObserver;
}

function setupIsMotion(root = document) {
  if (isMotionQuery.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('is-motion-ready');
  const observer = getMotionObserver();

  isRevealSelectors.forEach((selector) => {
    const elements = root.matches?.(selector) ? [root] : [...root.querySelectorAll(selector)];
    elements.forEach((element, index) => {
      if (isMotionItems.has(element)) return;
      isMotionItems.add(element);
      element.dataset.isReveal = element.matches('.is-hero__media, .is-personalization-story__media, .is-maker__media')
        ? 'media'
        : 'content';
      element.style.setProperty('--is-reveal-delay', `${Math.min(index * 55, 220)}ms`);
      observer.observe(element);
    });
  });
}

setupIsMotion();
document.addEventListener('shopify:section:load', (event) => setupIsMotion(event.target));

isMotionQuery.addEventListener?.('change', (event) => {
  if (event.matches) {
    document.documentElement.classList.remove('is-motion-ready');
    document.querySelectorAll('[data-is-reveal]').forEach((element) => element.classList.add('is-revealed'));
  } else {
    setupIsMotion();
  }
});
